import { render, staticRenderFns } from "./migrantsPeople.vue?vue&type=template&id=d5fdb6d2&scoped=true&"
import script from "./migrantsPeople.vue?vue&type=script&lang=js&"
export * from "./migrantsPeople.vue?vue&type=script&lang=js&"
import style0 from "./migrantsPeople.vue?vue&type=style&index=0&id=d5fdb6d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fdb6d2",
  null
  
)

export default component.exports